export default __webpack_public_path__ + "static/media/fahrrad-ventil-arten-scaled-1-620x346.50208e82.jpg";